@if ({}; as STATE) {
  <section class="reset-password-page">
    <auth-wrapper [title]="title" [description]="description">
      <reset-password-form></reset-password-form>
    </auth-wrapper>
  </section>
}
